import React, { useCallback } from "react";

import mail from "../images/mail.png";
import { useState, useEffect } from "react";
import { EnquiryDetails } from "../servies/services";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import SendImage from "../images/send.jpg"

const defaultValue = {
  firstName: null,
  lastName: null,
  email: null,
  mobile: null,
  message: null
};



const ContactForm = () => {
  const [user, setUser] = useState(defaultValue);
  const [searchParams] = useSearchParams();
  const query = searchParams.get("query");
  const [errors, setErrors] = useState();

  const handleChange = (e) => {
    // console.log(e);



    const { name, value } = e.target;
    if (name === 'subInquiry1' || name === 'subInquiry2' || name === 'subInquiry3' || name === 'subInquiry4') {
      const checked = e.target.checked;
      setUser({ ...user, [name]: checked });
    } else {
      setUser({ ...user, [name]: value });
    }



  };
  console.log("User ", user);



  const validate = useCallback(() => {
    let errors = {};
    const regExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;


    if (!user.firstName) errors.firstName = "First  Name is required!";
    else if (user?.firstName?.length < 3)
      errors.firstName = "First Name must be greater than 3 characters";

    if (!user.lastName) errors.lastName = "Last Name is required!";
    else if (user?.lastName?.length < 3)
      errors.lastName = "Last Name must be greater than 3 charectors";

    if (!user.email) errors.email = "Email is required!";
    else if (!regExp.test(user?.email))
      errors.email = "Email is not valid ";


    if (!user.mobile) errors.mobile = "Mobile is required !";

    //   if(checked) {

    //      user.subInquiry.filter((e) => (e!==value))
    //   }


    if (!user.message) errors.message = "Message is required!";
    else if (user?.message?.length < 3)
      errors.message = "Message must be greater than 3 characters";

    setErrors(errors);
  }, [user.email, user.firstName, user.lastName, user.message, user.mobile]);



  useEffect(() => {
    validate();
  }, [user, validate]);




  const submit = async () => {
    if (user.firstName?.length > 1 &&
      user.lastName?.length > 1 &&
      user.email?.length > 1 &&
      user.message?.length > 1
    ) {

      const userInput = {
        full_name: user.firstName + " " + user.lastName,
        business_name: query ?? '-',
        email_id: user.email,
        phone_number: user.mobile,
        commnet: user.message,
      }
      const response = await EnquiryDetails(userInput);
      console.log("response", response?.data?.data)
      if (response?.data?.isSuccess) {
        toast.success("Email has been sent");
        setUser(defaultValue)
      } else {
        toast.error("Something went wrong, please try again");
      }

    } else {
      toast.error("Fill all required fields");
    }
  }



  return (
    <>
      <div className="container inner-container">
        <div className="contact">
          <div className="row" >
            <div className="col-md-5">
              <div className="contact_info">

                <h3>Contact Information</h3>
                <p className="subheading"> Say something to start a live chat! </p>
                <ul>
                  <li> <a href="mailto:firstlightadv@gmail.com" target="_blank" rel="noreferrer" className="mail"> <img src={mail} alt="mail" /> firstlightadv@gmail.com </a> </li>
                  <li>
                    {/* <a href="https://maps.app.goo.gl/pFmhxprjNGRuM9fy6" target="_blank" rel="noreferrer" className="address">  <img src={address} alt="address" style={{ width:"18px" }} /> 132 Dartmouth Street Boston, Massachusetts 02156 United States </a> */}
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-7 contact_form">
              <div className="row pt-2">
                <div className="col-md-6 mb3">
                  <label htmlFor="firstName" className="form-label"> First Name *  </label>
                  <input type="text" className="form-control" name="firstName" value={user.firstName} placeholder="Enter your first name" onChange={handleChange} />
                  {user.firstName?.length > 1 && errors?.firstName && <p>{errors?.firstName}</p>}
                </div>

                <div className="col-md-6 mb3">
                  <label htmlFor="lastName" className="form-label"> Last Name * </label>
                  <input type="text" className="form-control" name="lastName" value={user.lastName} placeholder="Enter your Last name" onChange={handleChange} />
                  {user.lastName?.length > 1 && errors?.lastName && <p>{errors?.lastName}</p>}
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb3">
                  <label htmlFor="email" className="form-label"> Email Id  * </label>
                  <input type="email" className="form-control" name="email" value={user.email} placeholder="Enter your Email" onChange={handleChange} />
                  {user.email?.length > 1 && errors?.email && <p>{errors?.email}</p>}

                </div>

                <div className="col-md-6 mb3">
                  <label htmlFor="phoneNumber" className="form-label"> Phone Number (Optional)</label>
                  <input type="text" className="form-control" name="mobile" value={user.mobile} placeholder="Enter your mobile" onChange={handleChange} />
                  {user.mobile?.length > 1 && errors?.mobile && <p>{errors?.mobile}</p>}
                </div>
              </div>

              {/* <div className="row">  
                                  <h5> Select Subject? </h5>                                
                                  <div className="col-md-12 mb3 selectsub">
                                    
                                  <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="General Inquiry 1" id="check_1" name="subInquiry1" checked onChange={handleChange} />
                                        <label className="form-check-label" htmlFor="check_1">
                                          General Inquiry 1
                                        </label>
                                      </div>

                                      <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="General Inquiry 2" id="check_2" name="subInquiry2" onChange={handleChange} />
                                        <label className="form-check-label" htmlFor="check_2">
                                          General Inquiry 2 
                                        </label>
                                      </div>

                                      <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="General Inquiry 3" id="check_3" name="subInquiry3" onChange={handleChange} />
                                        <label className="form-check-label" htmlFor="check_3">
                                          General Inquiry 3  
                                        </label>
                                      </div>

                                      <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="General Inquiry 4" id="check_4" name="subInquiry4" onChange={handleChange}  />
                                        <label className="form-check-label" htmlFor="check_4">
                                          General Inquiry 4 
                                        </label>
                                      </div>
                                  </div> 
                                </div> */}


              <div className="row">
                <div className="col-md-12 mb3">
                  <label htmlFor="message" className="form-label"> Message *  </label>
                  <textarea className="form-control" name="message" value={user.message} placeholder="Enter your message" rows="1" cols="10" onChange={handleChange} />
                  {user.message?.length > 1 && errors?.message && <p>{errors?.message}</p>}
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mt-2 buttonsubmit_outer">
                  <img onClick={submit} className="btn-img" src={SendImage} alt="" title=""></img>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


    </>
  )
};

export default ContactForm;     